<div class="xvi-modal-link-renderer">
  <span (click)="showModalDialog($event)">{{ value | translate }}</span>
</div>
